import PageListComponent from '../components/page-list/pageList'

const PageList = () => <PageListComponent />

export default PageList;